import { Badge, Box, Card, Divider, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

type ContentSectionProps = {
  header?: string;
  showHeaderCounter?: boolean;
  headerCounter?: number;
  showAlertBadge?: boolean;
  hasError?: boolean;
  button?: JSX.Element;
  transparentBackground?: boolean;
  children: ReactNode;
  mb?: number;
  border?: boolean;
  /** Storlek på rubriken — default 'h6' (~1.25rem). Använd 'subtitle1' (1rem) eller 'subtitle2' (0.875rem) för mindre. */
  headerVariant?: TypographyProps['variant'];
  /** Tjocklek på rubrik-fonten — default 700 (bold). */
  headerFontWeight?: number;
};

export const ContentSection = (props: ContentSectionProps) => {
  const {
    header = undefined,
    showHeaderCounter = false,
    headerCounter = 0,
    showAlertBadge = false,
    // Luft i stället för linjer: avsnitten avgränsas av tomrum, inte av en regel under
    // varje rubrik. En sida med tio avsnitt får annars tio streck och känns rutig.
    //
    // Avståndet ägs av layouten, inte av avsnittet. Sidorna lägger varje avsnitt i ett eget
    // rutnätselement med 24px radavstånd, och en egen marginal här ovanpå det gav olika
    // avstånd beroende på om två avsnitt låg i samma element eller i var sitt.
    mb = undefined,
    border = false,
    hasError = false,
    button = undefined,
    transparentBackground = false,
    headerVariant = 'h6',
    headerFontWeight = 700,
    children,
  } = props;

  return (
    <Card
      sx={{
        ...(hasError ? { borderWidth: 2, borderStyle: 'solid', borderColor: 'error.dark' } : null),
        position: 'relative',
        backgroundColor: transparentBackground ? 'transparent' : '#fff',
        mb,
      }}
      {...(hasError ? { variant: 'outlined' } : null)}
      elevation={0}
    >
      {header && (
        <>
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Typography variant={headerVariant} sx={{ fontWeight: headerFontWeight }} gutterBottom>
              {showAlertBadge ? (
                <Badge
                  badgeContent={headerCounter && headerCounter}
                  sx={{ '.MuiBadge-badge': { marginRight: '-18px', marginTop: '10px' } }}
                  color='error'
                  // anchorOrigin={{
                  //   vertical: 'top',
                  //   horizontal: 'left',
                  // }}
                >
                  {header}
                </Badge>
              ) : (
                <>
                  {header}
                  {showHeaderCounter && (
                    <Typography
                      component='span'
                      sx={{
                        fontWeight: 100,
                        ml: 0.5,
                      }}
                    >
                      {`(${headerCounter})`}
                    </Typography>
                  )}
                </>
              )}
            </Typography>
            {button}
          </Box>
          {border && <Divider sx={{ mb: 1 }} />}
        </>
      )}
      {children}
    </Card>
  );
};
